module.exports = __webpack_public_path__ + "static/ecologie-6cb2d959b27c3d2dcaff77d54ff0ec15.jpg";